import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import { useNavigate } from 'react-router-dom'
import axiosClient from '../axios-client';
import { useStateContext } from "../contexts/ContextProvider";
import { useEffect, useState } from "react";
import jwt_decode from 'jwt-decode';
import axios from "axios";



const defaultTheme = createTheme();

function CustomUserInput() {
  const google = window.google;

  const textInputs = [
    {
      type:'text',
      name:'reg-number',
      required:true,
      placeholder:'enm211-0180/2020',
      autoFocus:true,
      id:0,
    },
    {
      type:'text',
      name:'phone',
      required:true,
      placeholder:'0720000000',
      autoFocus:true,
      id:1,
    },
  ]


  const [user, setUser] = useState({
    name: '',
    email: '',
    email_verified: true,
    google_id: '',
    picture_url: ''

  });
  localStorage.clear()
  const [showAlert, setShowAlert] = useState(false);

  const [campuses, setCampuses] = useState([]);

  const [hall, setHall] = useState([]);
  const [googleSignInCompleted, setGoogleSignInCompleted] = useState(false);
  const [googleUserData, setGoogleUserData] = useState(null);
  const navigate = useNavigate();
  const [reg_error, setReg_error] = useState(null);
  const [email, setEmail] = useState(null);
  const [email_verified, setEmail_verified] = useState(null);
  const [phone, setPhone] = useState(null);
  const [name, setName] = useState(null);
  const [picture, setPicture] = useState(null);
  const [hallError, setHallError] = useState(null)
  const [campusError, setCampusError] = useState(null)

  React.useEffect(() => {

    axios.get('https://mykura-nodejs-backend-fca8901da273.herokuapp.com/api/data')
      .then(function (response) {
        // handle success
        console.log(response.data); //data is in json format
        setCampuses(response.data.campuses)
        setHall(response.data.halls)
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
   
  }, [])

  function CallGoogle() {

  useEffect(() => {

    /* global google*/
    google.accounts.id.initialize({
      client_id: "808107932931-ju82luml7dvd2agng4aktdimjfhbrdh1.apps.googleusercontent.com",
      callback: handlecallbackResponse
    })
    google.accounts.id.renderButton(
      document.getElementById("signInDiv"),
      { theme: "outline", size: "large", shape: "pill" }
    )
    // google.accounts.id.prompt()
    
  }, []);
  
}
CallGoogle()

  function handlecallbackResponse(response) {
    console.log("Encoded JWT ID token: " + response.credential)
    const userObject = jwt_decode(response.credential)

    setUser({
      ...user,
      email: userObject.email,
      email_verified: userObject.email_verified,
      google_id: userObject.sub,
      name: userObject.name,
      picture: userObject.picture,
    });
    setGoogleSignInCompleted(true);

    console.log(user.email)
    document.getElementById("signInDiv").hidden = true


  }
  // process form data
  const handleSubmit = (event) => {
    // debugger;

    event.preventDefault();
    let data = {};

    const form = new FormData(event.target);

    const payload = {

      reg_number: form.get('reg-number'),
      phone: form.get('phone'),
      hall: form.get('hall'),
      campus: form.get('campus'),
      name: user.name,
      email: user.email,
      email_verified: user.email_verified,
      picture_url: user.picture,

    }
    console.log(payload)

    //add payload from gsi
    const url = 'https://mykura-nodejs-backend-fca8901da273.herokuapp.com/api/signup'
    const url2 = 'http://localhost:5000/api/signup'
    axios.post(url2, payload)
      .then(response => {

        console.log(response);
        // setUser(response.data.user)
        // setToken(response.data.token)

      }).catch(error => {

        console.log(error);

        setReg_error(error.response.data.errors)
        setEmail(error.response.data.errors.email)
        setName(error.response.data.errors.name)
        setPicture(error.response.data.errors.picture)
        setEmail_verified(error.response.data.errors.email_verified)
        setPhone(error.response.data.errors.phone)
        setHallError(error.response.data.errors.hall)
        setCampusError(error.response.data.errors.campus)

      })

      // Swal.fire({
      // icon: 'success',
      // title: 'Success',
      // text: 'Activation link, sent to your email. Check your inbox to activate your account'
      // })

      .catch(function (error) {
        // handle error
        console.log(error);
      })

  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <div className='h-screen flex flex-col items-center mt-[20%] sm:mt-0 sm:justify-center'>
        <CssBaseline />
        <div
        className='mt-8 flex flex-col items-center sm:mt-0'
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>

          <h3 
          style={{fontFamily: "Kaushan Script"}}
          className='font-semibold text-xl'>Sign up</h3>
          
          <h1 
          className='font-bold my-4 text-2xl'
          >Fill in the below details</h1>
          
          <form 
          className='mt-3 w-[350px]'
          onSubmit={handleSubmit}
          action="">

            <div className='grid gap-4'>
              {reg_error && (<Alert severity="error" onClose={() => setReg_error(null)}><AlertTitle>{reg_error}</AlertTitle></Alert>)}
              {phone && (<Alert severity="error" onClose={() => setPhone(null)}><AlertTitle>{phone}</AlertTitle></Alert>)}

              {textInputs.map((d) => {
                const {type,name,placeholder,id} = d
                return (
                  <div 
                  className='grid gap-1 font-semibold'
                  key={id}>
                    <label 
                    className='capitalize'
                    htmlFor="">{name}</label>
                    <input
                    className='bg-transparent  px-2 py-2 rounded-sm border-none outline-none ring-2 ring-slate-400 text-slate-900 focus:ring-blue '
                    type={type}
                    name = {name}
                    placeholder={placeholder}
                    aria-required
                    required
                    autoFocus
                    />
                  </div>
                )
              })}

              <select 
              className='bg-transparent  px-2 py-2 rounded-sm border-none outline-none ring-2 ring-slate-400 text-slate-900 focus:ring-blue '
              name="campus" id="campus">
                <option
                className='w-full'
                >Select Campus</option>
                {campuses.map(campus => (
                  <option 
                  className='w-full'
                  key={campus} value={campus}>
                    {campus}
                  </option>
                ))}
              </select>
              {campusError && (<Alert severity="error" onClose={() => setCampusError(null)}><AlertTitle>{campusError}</AlertTitle></Alert>)}

              <select 
              className='bg-transparent  px-2 py-2 rounded-sm border-none outline-none ring-2 ring-slate-400 text-slate-900 focus:ring-blue '
              name="hall" id="hall">
                <option>Select Hall</option>
                {hall.map(hall => (
                      <option key={hall} value={hall}>
                        {hall}
                      </option>
                ))}
              </select>
              {hallError && (<Alert severity="error" onClose={() => setHallError(null)}><AlertTitle>{hallError}</AlertTitle></Alert>)}              
              
              <div id='signInDiv'></div>
              
            {email && (<Alert severity="error" onClose={() => setEmail(null)}><AlertTitle>{email}</AlertTitle></Alert>)}
            {email_verified && (<Alert severity="error" onClose={() => setEmail_verified(null)}><AlertTitle>{email_verified}</AlertTitle></Alert>)}
            {name && (<Alert severity="error" onClose={() => setName(null)}><AlertTitle>{name}</AlertTitle></Alert>)}
            

              <button 
              className='text-white bg-blue rounded-sm flex items-center justify-center font-semibold w-full py-2 disabled:bg-blue/25'
              
              type='submit'>
                Sign up
              </button>

              <Link
              to='/sign-in'
              className='text-blue font-semibold mt-2'
              >
                Already have an account? Sign in
              </Link>
            </div>


          </form>
        </div>
      </div>
    </ThemeProvider>

  );

}

export default function Signup() {
  return <CustomUserInput />;
}